import {Component, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {TranslatePipe, TranslateService} from '@ngx-translate/core';
import {Title} from '@angular/platform-browser';
import {PageSelectorComponent} from '@/app/shared';
import {NgClass} from '@angular/common';
import {SeasonService} from '@services/season.service';
import {LeaderboardEntry} from '@/app/core/models/bet/leaderboardEntry';
import {BetLeaderboardPodiumComponent} from '@/app/pages/bet-leaderboard/bet-leaderboard-podium/bet-leaderboard-podium.component';
import {LeaderboardService} from '@services/leaderboard.service';
import {AuthService} from '@services/auth.service';

@Component({
	selector: 'peps-bet-leaderboard',
	imports: [
		TranslatePipe,
		PageSelectorComponent,
		NgClass,
		BetLeaderboardPodiumComponent,
	],
	templateUrl: './bet-leaderboard.component.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrl: './bet-leaderboard.component.css',
})
export class BetLeaderboardComponent implements OnInit {

	constructor(
		private readonly leaderboardService: LeaderboardService,
		private readonly seasonService: SeasonService,
		private readonly authService: AuthService,
		private readonly titleService: Title,
		private readonly translate: TranslateService
	) {}

	ngOnInit(): void {
		this.titleService.setTitle(this.translate.instant('page.leaderboard.title'));
		this.loadYears();
		if (this.authService.isAuthenticated()) {
			this.currentUsername = this.authService.getUser()!.username;
		}
	}

	years: number[] = [];
	selectedYear: number | null = null;
	podium: LeaderboardEntry[] = [];
	leaderboards: LeaderboardEntry[] = [];
	currentUsername: string | null = null;

	page: number = 0;
	totalPages: number = 0;
	isOpen = false;

	private loadYears(): void {
		this.seasonService.getYears().subscribe({
			next: (years) => {
				this.years = years.slice().sort((a, b) => b - a);
				if (this.years.length > 0) {
					this.selectedYear = this.years[0];
					this.loadPodium();
					this.loadLeaderboard();
				}
			}
		});
	}

	loadPodium(): void {
		if (this.selectedYear === null) return;
		this.leaderboardService.getPodium(this.selectedYear).subscribe({
			next: (data) => { this.podium = data; }
		});
	}

	loadLeaderboard(): void {
		if (this.selectedYear === null) return;
		this.leaderboardService.getLeaderboard(this.selectedYear, this.page).subscribe({
			next: (data) => {
				this.leaderboards = data.content;
				this.totalPages = data.totalPages;
			}
		});
	}

	selectYear(year: number): void {
		this.selectedYear = year;
		this.page = 0;
		this.isOpen = false;
		this.loadPodium();
		this.loadLeaderboard();
	}

	onPageChange(newPage: number): void {
		this.page = newPage;
		this.loadLeaderboard();
	}

	toggleOpen(): void {
		this.isOpen = !this.isOpen;
	}
}
